import { useMutation, useQueryClient } from "react-query";
import Auth from "shared/@auth";

/**
 * Data hook for adding new tag options.
 *
 * @param optionName - one of 'countries', 'languages', or 'tags'
 */
export function useOptionData(optionName) {
  const client = useQueryClient();
  const { makeAuthedRequest } = Auth.useContainer();

  const addMutation = useMutation(
    (data) => {
      return makeAuthedRequest(`/cms/options/${optionName}`, {
        method: "post",
        body: JSON.stringify(data),
      });
    },
    {
      onSuccess: () => {
        return client.invalidateQueries(["cms"]);
      },
    }
  );

  const deleteMutation = useMutation(
    (id) => {
      return makeAuthedRequest(
        `/cms/options/${optionName}/${encodeURIComponent(id)}`,
        { method: "delete" }
      );
    },
    {
      onSuccess: () => {
        return client.invalidateQueries(["cms"]);
      },
    }
  );

  return {
    addMutation,
    deleteMutation,
  };
}
